import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mainCategoryServices } from '../services/main-category.service';

export const useUpdateMainCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mainCategoryServices.updateMainCategory,
    onSuccess: () => {
      queryClient.invalidateQueries(['main-category']);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update main category');
    },
  });
};
